import React, { Fragment, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import classes from 'classnames';
import SubjectView from './SubjectView';
import ThemedFooterButton from '../../components/themed/ThemedFooterButton';
import ShortSubjectsList from '../../components/training/ShortSubjectsList';
import TrainingCompleted from '../Trainings/TrainingCompleted';

export default function SubjectsIdRouteElement({
    isFinished,
    training,
    isDemo,
    store,
    isScorm,
    showMobileMenu,
    hideLessonMenu,
    certificateQualified,
    assessmentAvailable,
    parentUrl,
    subjectId,
    subject,
    videoTokenStore,
    availableUnfinishedSubjects,
    lastNextEnabled,
    onFinish,
    handleClosePage,
}) {
    const { t } = useTranslation();

    const index = _.findIndex(
        availableUnfinishedSubjects,
        (x) => x.id === Number(subjectId)
    );
    const isCompleted = index < 0;
    const isFirst = index === 0;
    const isLast = index === availableUnfinishedSubjects.length - 1;

    useEffect(() => {
        console.log("re-mounting SubjectsIdRouteElement");
    }, []);

    return (
        <Fragment>
            {isFinished ? (
                <div className="wizard-body">
                    <TrainingCompleted
                        training={training}
                        isDemo={isDemo}
                        store={store}
                        isScorm={isScorm}
                    />
                </div>
            ) : (
                <div className="wizard-body">
                    <div
                        className={classes('sidebar ', {
                            open: showMobileMenu,
                        })}
                        onClick={() => hideLessonMenu()}
                    >
                        <ShortSubjectsList
                            certificateQualified={certificateQualified}
                            assessment_id={training.assessment_id}
                            assessmentAvailable={assessmentAvailable}
                            onCertificateRequest={onFinish}
                            subjects={training.subjects}
                            parentUrl={parentUrl}
                            selectedId={subjectId}
                        />
                        {subject && subject.type !== 2 && (
                            <div className="btn-fixed">
                                <Button className="btn-link">
                                    {t('Back to training')}
                                </Button>
                            </div>
                        )}
                    </div>
                    <div className={'wizard-content'}>
                        <SubjectView
                            training={training}
                            subject={subject}
                            store={store}
                            videoTokenStore={videoTokenStore}
                            isDemo={isDemo}
                            language={store.language}
                        />
                    </div>
                </div>
            )}
            {((subject && subject.type !== 2) || isCompleted) && (
                <div className={'wizard-footer'}>
                    <div className={'actions'}>
                        {!isFirst && !isCompleted && (
                            <Button
                                tag={Link}
                                className="mobile-arrow-back"
                                color={'link'}
                                size={'lg'}
                                to={`${parentUrl}/subjects/${
                                    availableUnfinishedSubjects[index - 1]
                                        .id
                                }`}
                            >
                                {t('Previous')}
                            </Button>
                        )}
                        {!isLast && (
                            <ThemedFooterButton
                                mode="primary"
                                continue
                                to={`${parentUrl}/subjects/${
                                    availableUnfinishedSubjects[index + 1]
                                        .id
                                }`}
                                text={t('Next lesson')}
                            ></ThemedFooterButton>
                        )}
                        {(isLast) &&
                            !isFinished && (
                                <ThemedFooterButton
                                    mode="primary"
                                    disabled={
                                        availableUnfinishedSubjects.length >
                                            0 || !lastNextEnabled
                                    }
                                    continue
                                    onClick={onFinish}
                                    text={t('Finish')}
                                ></ThemedFooterButton>
                            )}
                        {isLast && isFinished && (
                            <ThemedFooterButton
                                mode="primary"
                                continue
                                onClick={handleClosePage}
                                text={t('Finish')}
                            ></ThemedFooterButton>
                        )}
                    </div>
                </div>
            )}
        </Fragment>
    );
}


